// Webpack Imports
import 'bootstrap';

var Masonry = require('masonry-layout');

(function ($) {
    'use strict';
    $(document).ready(function () {
        $("body").fadeTo(300, 1);

        $( ".btn-search" ).click(function() {
            $(this).parent().toggleClass('active');
            $(this).parent().find('input').focus();
        });

        var $status = $('.pagingInfo');
        var $slickSlider = $('.slideshow');
        var $slickAmbasador = $('.ambasadors');
        var $slickPartners = $('.partners');

        $slickSlider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
            var i = (currentSlide ? currentSlide : 0) + 1;
            $status.text('0' + i);
        });


        $('#video-gallery').lightGallery({
            videojs: true,
            thumbnail: false,
            download: false,
            share: false,
            rotate: false,
            zoom: false,
            autoplayControls: false
        });

        $('#gallery').lightGallery({
            videojs: true,
            thumbnail: false,
            download: false,
            share: false,
            rotate: false,
            zoom: false,
            autoplayControls: false
        });
        $(".open_gallery").click(function (e) {
            e.preventDefault();
            $($.attr(this, 'href')).trigger("click");
        });
        $(".open_video").click(function (e) {
            e.preventDefault();
            $($.attr(this, 'href')).trigger("click");
        });

        $slickSlider.slick({
            infinite: true,
            slidesToShow: 1,
            autoplay: false,
            dots: false
        });

        $slickAmbasador.slick({
            infinite: true,
            slidesToShow: 2,
            autoplay: false,
            dots: false,
            responsive: [
                {
                    breakpoint: 770,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        $slickPartners.slick({
            infinite: true,
            slidesToShow: 5,
            autoplay: false,
            dots: false,
            arrow: false,
            responsive: [
                {
                    breakpoint: 770,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 420,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        $('.navbar-toggler').click(function (e) {
            $('body').toggleClass('nav-active');
        });

        $('.slider-for').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: '.slider-nav'
        });
        $('.slider-nav').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.slider-for',
            dots: true,
            centerMode: true,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 770,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });

    $(window).load(function () {
        if ($('.post-grid').length) {
            var msnry = new Masonry('.post-grid');
        }
    });

    $(document).ajaxComplete(function() {
        if ($('.post-grid').length) {
            var msnry = new Masonry('.post-grid');
        }
    });
    
    const $dropdown = $(".dropdown");
    const $dropdownToggle = $(".dropdown-toggle");
    const $dropdownMenu = $(".dropdown-menu");
    const showClass = "show";

    $(window).on("load resize", function () {
        if (this.matchMedia("(min-width: 768px)").matches) {
            $dropdown.hover(
                function () {
                    const $this = $(this);
                    $this.addClass(showClass);
                    $this.find($dropdownToggle).attr("aria-expanded", "true");
                    $this.find($dropdownMenu).addClass(showClass);
                },
                function () {
                    const $this = $(this);
                    $this.removeClass(showClass);
                    $this.find($dropdownToggle).attr("aria-expanded", "false");
                    $this.find($dropdownMenu).removeClass(showClass);
                }
            );
        } else {
            $dropdown.off("mouseenter mouseleave");
        }
    });

}(jQuery));
